module.exports = __webpack_public_path__ + "img/google_analytics.97cd56e5.svg";